/**
 * Bell contract pricing by rate plan and volume tier
 * Volume tiers: 0-100 = tier1, 101-500 = tier2, 501+ = tier3
 * Only activated SIMs are billed
 */
export const BELL_PRICING: Record<string, { tier1: number; tier2: number; tier3: number; poolMB: number }> = {
  'ATEK 1 GB Cdn Shared': { tier1: 12.60, tier2: 11.34, tier3: 10.08, poolMB: 1024 },
  'ATEK 10 MB Cdn Shared': { tier1: 3.15, tier2: 2.84, tier3: 2.52, poolMB: 10 },
  'ATEK 25 MB Cdn Shared': { tier1: 4.41, tier2: 3.97, tier3: 3.53, poolMB: 25 },
  'ATEK 250 MB Cdn Shared': { tier1: 7.56, tier2: 6.80, tier3: 6.05, poolMB: 250 },
  'ATEK 50 MB Canada Share': { tier1: 5.50, tier2: 4.95, tier3: 4.40, poolMB: 50 },
  'ATEK 100 MB Canada Share': { tier1: 6.50, tier2: 5.85, tier3: 5.20, poolMB: 100 },
  'Atek 10 MB N.A. Share': { tier1: 4.50, tier2: 4.05, tier3: 3.60, poolMB: 10 },
  'Atek 25 MB N.A. Share': { tier1: 5.75, tier2: 5.18, tier3: 4.60, poolMB: 25 },
  'Atek 50 MB N.A. Share': { tier1: 7.00, tier2: 6.30, tier3: 5.60, poolMB: 50 },
  'Atek 100 MB N.A. Share': { tier1: 8.50, tier2: 7.65, tier3: 6.80, poolMB: 100 },
  'Atek 250 MB N.A. Share': { tier1: 10.00, tier2: 9.00, tier3: 8.00, poolMB: 250 },
};

export type VolumeTier = 'tier1' | 'tier2' | 'tier3';

/**
 * Get the monthly cost for a SIM card based on rate plan, status, and volume tier
 * Only active SIMs are billed
 */
export function getSimMonthlyCost(
  ratePlan: string | null,
  status: string,
  volumeTier: VolumeTier = 'tier2'
): number | null {
  // Only active SIMs are billed
  if (status !== 'active') {
    return 0;
  }

  if (!ratePlan) {
    return null; // Unknown cost
  }

  const pricing = BELL_PRICING[ratePlan];
  if (!pricing) {
    return null; // Rate plan not in pricing table
  }

  return pricing[volumeTier];
}

/**
 * Format cost for display
 */
export function formatCost(cost: number | null): string {
  if (cost === null) {
    return '-';
  }
  if (cost === 0) {
    return '$0.00';
  }
  return `$${cost.toFixed(2)}`;
}
